import { createAuthClient } from "better-auth/react";

// Get the base URL dynamically based on current hostname
function getBaseURL() {
  // Server-side: use environment variable
  if (typeof window === "undefined") {
    return (
      process.env.NEXT_PUBLIC_APP_URL ||
      process.env.BETTER_AUTH_URL ||
      "http://localhost:3000"
    );
  }

  // Client-side: use current origin to support production deployment
  return window.location.origin;
}

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
  fetchOptions: {
    credentials: "include", // CRITICAL: Ensures cookies are sent with requests
  },
});

export const { signIn, signUp, signOut, useSession } = authClient;

export type Session = typeof authClient.$Infer.Session;
